/**
 * Trader Dashboard Theme Constants
 *
 * Professional Trading Terminal Color Theme
 * Consistent palette for readability and reduced eye strain
 */

export const traderTheme = {
  // Background colors
  bg: {
    primary: '#0a0e14',
    secondary: '#0d1117',
    hover: 'rgba(255, 255, 255, 0.04)',
    row: 'rgba(255, 255, 255, 0.02)',
  },
  // Text colors
  text: {
    primary: '#e6edf3',
    secondary: '#7d8590',
    muted: '#484f58',
  },
  // Semantic colors
  profit: '#3fb950',    // Single green for all positive
  loss: '#f85149',      // Single red for all negative
  // Price colors (Bloomberg-style amber)
  price: {
    primary: '#f0883e',   // Main price color
    spot: '#58a6ff',      // Blue for spot
    futures: '#a371f7',   // Purple for futures
  },
  // Status colors
  warning: '#d29922',
  danger: '#da3633',
  // UI colors
  border: '#30363d',
  accent: '#58a6ff',
  accentHover: '#79c0ff',
} as const;

export type TraderTheme = typeof traderTheme;
